/**
 * @author: taufan.gumelar@xapiens.id
*/

import React from 'react';

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  {
    path: '/master/agent',
    exact: true,
    name: 'Agent',
    component: React.lazy(() => import('./agents/views/Agent')),
  },
  {
    path: '/master/client',
    exact: true,
    name: 'Client',
    component: React.lazy(() => import('./client/views/Client')),
  },
  {
    path: '/master/contract-client',
    exact: true,
    name: 'Contract Client',
    component: React.lazy(() => import('./contracts/views/Contract')),
  },
  {
    path: '/master/business-partner',
    exact: true,
    name: 'Business Partner',
    component: React.lazy(() => import('./business-partner/views/BusinessPartner')),
  },
  {
    path: '/master/supplier',
    exact: true,
    name: 'Supplier',
    component: React.lazy(() => import('./supplier/views/Supplier')),
  },
  {
    path: '/master/material',
    exact: true,
    name: 'Material',
    component: React.lazy(() => import('./materials/views/Materials')),
  },
  {
    path: '/master/approval',
    exact: true,
    name: 'Approval',
    component: React.lazy(() => import('./approval/views/Approval')),
  },
  {
    path: '/master/delay',
    exact: true,
    name: 'Delay',
    component: React.lazy(() => import('./delay/views/Delay')),
  }
];

export default routes;
